"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayoutForPayoutsPage = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const Payout_1 = require("../models/Payout");
const SimpleUser_1 = require("../models/SimpleUser");
class PayoutForPayoutsPage {
    simpleUser;
    payout;
    assignationPayoutsAmount;
    debtsAmount;
    currency;
    baselessAmount;
}
exports.PayoutForPayoutsPage = PayoutForPayoutsPage;
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Type)(() => SimpleUser_1.SimpleUser),
    __metadata("design:type", SimpleUser_1.SimpleUser)
], PayoutForPayoutsPage.prototype, "simpleUser", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Type)(() => Payout_1.Payout),
    __metadata("design:type", Payout_1.Payout)
], PayoutForPayoutsPage.prototype, "payout", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], PayoutForPayoutsPage.prototype, "assignationPayoutsAmount", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], PayoutForPayoutsPage.prototype, "debtsAmount", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(legacy_enums_1.Currency),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], PayoutForPayoutsPage.prototype, "currency", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], PayoutForPayoutsPage.prototype, "baselessAmount", void 0);
//# sourceMappingURL=PayoutForPayoutsPage.js.map